const linearPreviewHeight = 120;
const circularPreviewHeight = 300;
const bottomPadding = 45;
const paddingLinearEditor = 20;

export {
    linearPreviewHeight,
    circularPreviewHeight,
    bottomPadding,
    paddingLinearEditor,
}